module.exports = __webpack_public_path__ + "static/img/hy02.f3401371.png";